<div
class="flex max-xl:flex-row  max-sm:flex-col gap-4 apearAnimation"
  style="background-color: rgb(255, 255, 255)"
>
  <div
    class="max-sm:basis-full md:basis-1/3 flex flex-col justify-center mx-4 max-sm:justify-self-center"
  >
<div class=" flex justify-self-center justify-center">
  <img class="justify-self-center"
  src="../../../../assets/images/livasLogo.png"
  style="width: 200px; height:auto"
/>
</div>

    <div>
      <h1 class="font-bold">Recuperar Contraseña</h1>
    </div>
    <div>
      <h2>Escriba una nueva contraseña y confirmela</h2>
    </div>

    <div>
      <form
        [formGroup]="registerForm"
        (ngSubmit)="restorePwd()"
        class="example-form"
      >
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Contraseña</mat-label>
          <input
            type="password"
            formControlName="password"
            matInput
            placeholder="Escriba la contraseña"
            value=""
            autocomplete="false"
          />
          <mat-error>{{ getValidationErrorPassword() }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Confirmar contraseña</mat-label>
          <input
            type="password"
            formControlName="passwordCnf"
            matInput
            placeholder="Repita la contraseña"
            value=""
          />
          <mat-error>{{ validatePwdEquality() }}</mat-error>
        </mat-form-field>
        <button
          type="submit"
          mat-flat-button
          color="primary"
          style="width: 100%"
          disabled="{{ this.registerForm.invalid }}"
        >
          Guardar contraseña
        </button>
      </form>
    </div>
  </div>

  <div class="md:basis-2/3  max-sm:collapse md:visible">
    <img
      src="../../../../assets/images/piscinasBg1.jpeg"
      style="width: 100%; height: 100vh"
    />
  </div>
</div>
